import { FC } from 'react';

import { GroupsPlaceholder, IGroupsPlaceholderProps } from '@gem/components';

type ISpaceCollectionListPlaceholderProps = IGroupsPlaceholderProps;

export const SpaceCollectionListPlaceholder: FC<ISpaceCollectionListPlaceholderProps> = (props) => {
  return <GroupsPlaceholder {...props} />;
};
